import controller from './thing-updated.controller';

const template = require('./thing-updated.html');

export default {
    bindings: {
        reset: '<',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-updated/thing-updated.component.js